import React, { useState } from 'react';
import { Icon, Table, TableColumnOpcoes } from '@components';
import { useDispatch } from 'react-redux';
import { deleteTemplateConector, getTemplateConectoresSuccess } from '@ducks/conectoresTemplates';

export default function TableTemplates({ data }) {
  const dispatch = useDispatch();
  const [conectoresRelacionados, setConectoresRelacionados] = useState(data);

  const removeItem = (idConfiguracao, idFonteDado) => {
    const conectores = [
      ...conectoresRelacionados.filter((con) => !(con.idConfiguracao === idConfiguracao && con.idFonteDado === idFonteDado)),
    ];

    setConectoresRelacionados(conectores);
    dispatch(getTemplateConectoresSuccess(conectores));
    dispatch(deleteTemplateConector(idConfiguracao, idFonteDado));
  };

  const columns = [
    {
      title: 'Conector',
      dataIndex: 'conectorIdentify',
      key: 'conectorIdentify',
      width: '45%',
    },
    {
      title: 'Fonte de dado',
      dataIndex: 'nmFonte',
      key: 'nmFonte',
      width: '45%',
    },
    {
      title: 'Opções',
      dataIndex: 'idConfiguracao',
      key: 'options',
      align: 'right',
      width: '15%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Delete
            popConfirmTitle='Deseja excluir a relação do template com essa fonte de dados?'
            action={() => removeItem(item.idConfiguracao, item.idFonteDado)}
          />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='idConfiguracao' columns={columns} dataSource={conectoresRelacionados} hidePagination />;
}
